import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import classNames from 'classnames';
import { useNotificationListProviderContext } from '../NotificationList.Context/NotificationList.Context.es.js';
import { Description } from '../NotificationList.Item.Description/NotificationList.Item.Description.es.js';
import { RelativeDateTime } from '../NotificationList.Item.RelativeDateTime/NotificationList.Item.RelativeDateTime.es.js';
import { Title } from '../NotificationList.Item.Title/NotificationList.Item.Title.es.js';

const NotificationListItem = ({ className, isRead = false, onClick, children })=>{
    const ariaId = useId();
    const { loading, locale: { unread = 'Unread Notification: View Details', read = 'Read Notification: View Details' } = {} } = useNotificationListProviderContext();
    return jsxs("li", {
        className: classNames('cb-notification-list-item', className, {
            loading,
            isRead
        }),
        children: [
            jsxs("div", {
                "aria-hidden": "true",
                className: classNames('children'),
                id: ariaId,
                children: [
                    !isRead && !loading && jsx("div", {
                        className: "unread-mark",
                        "data-testid": "unread-marker"
                    }),
                    children
                ]
            }),
            !loading && jsx("button", {
                "aria-describedby": ariaId,
                "aria-label": isRead ? read : unread,
                onClick: onClick
            })
        ]
    });
};
NotificationListItem.displayName = 'NotificationList.Item';
NotificationListItem.Title = Title;
NotificationListItem.Description = Description;
NotificationListItem.RelativeDateTime = RelativeDateTime;

export { NotificationListItem };
//# sourceMappingURL=NotificationList.Item.es.js.map
